export const DATA_FRESHNESS_LOOKUP = {
  1: {
    code: 1,
    label: "Latest",
    description: "Latest round, reported within the last 12 months.",
    color: "green",
  },
  2: {
    code: 2,
    label: "Legacy Latest",
    description: "Latest available round, but reported over 12 months ago.",
    color: "orange",
  },
  3: {
    code: 3,
    label: "Historical",
    description: "Older round, reported over 12 months ago.",
    color: "gray",
  },
  4: {
    code: 4,
    label: "Recent previous",
    description: "Recent round, but a newer round is available.",
    color: "blue",
  },
};

export const getDataFreshness = (value) =>
  DATA_FRESHNESS_LOOKUP[Number(value)] || null;
